import { createSlice } from '@reduxjs/toolkit';
// import productsData from '../data/products';
// import usersData from '../data/users';

const initialState = {
  stream_ouput_data: [],
  myFileRes: [10]
};

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setStream_ouput_data: (state, action) => {
      state.stream_ouput_data = action.payload;
    },
    setMyFileRes: (state, action) => {
      state.users = action.payload;
    }
  }
});

export const { setStream_ouput_data } = dataSlice.actions;
export default dataSlice.reducer;